export default "__VITE_ASSET__CHn7HOu0__"